{
  "loading": "Loading Face Off runs...",
  "empty": "No Face Off runs yet.",
  "error": "Face Off runs could not be loaded.",
  "intro": "Every daily FR-regression run, newest first. A flip is a face that crossed the accept cut-off since the run before, and it alerts. A shift is a score move past the golden band that stayed on the same side of the cut-off; it is reported but does not alert. Click a run to see both.",
  "columns": {
    "started": "Started",
    "goldenVersion": "Golden version",
    "pass": "Pass",
    "flips": "Flips",
    "worse": "Worse",
    "better": "Better",
    "shifts": "Shifts"
  },
  "passCell": "{rate} ({passed}/{total})",
  "rebaselineRow": "re-baseline from v{baselineFrom}, not drift",
  "noCount": "—",
  "goldenLink": "Golden set",
  "backToRuns": "All runs",
  "diff": {
    "loading": "Loading this run...",
    "error": "This Face Off run could not be loaded.",
    "notFound": "This Face Off run was not found.",
    "heading": "Run {runId}",
    "summary": "Golden v{goldenVersion}, {passed} of {total} passed ({passRate}), drift band ±{band}",
    "rebaseline": "Re-baseline from golden v{baselineFrom}",
    "flips": "Flips",
    "shifts": "Shifts",
    "noFlips": "No flips in this run.",
    "noShifts": "No shifts in this run.",
    "keysHelp": "Focus a flip, then press A to accept, W for wrong, U for unsure. Tab and Shift+Tab move between flips. Accept means the engine's answer now is right; wrong means it is not; unsure asks again next time.",
    "before": "Before",
    "after": "After",
    "noScore": "none",
    "photoPlaceholder": "No photo",
    "candidatePlaceholder": "No training photo",
    "person": "Person {personId}",
    "camp": "Camp {clientId}",
    "album": "Album {albumId}",
    "openAlbum": "Open in album",
    "saving": "Saving...",
    "saveError": "The verdict could not be saved.",
    "noVerdict": "No verdict",
    "cardLabel": "Person {personId}, {verdict}",
    "verdicts": {
      "accept": "Accept",
      "reject": "Wrong",
      "unsure": "Unsure"
    },
    "change": "{before} → {after}",
    "state": {
      "accepted": "accepted",
      "recorded": "not accepted",
      "absent": "absent"
    },
    "scoreDelta": "({delta})",
    "scan": "Scan: {scan}",
    "notePlaceholder": "note",
    "training": "Training photo"
  },
  "golden": {
    "heading": "Golden set",
    "loading": "Loading golden versions...",
    "error": "Golden versions could not be loaded.",
    "empty": "No golden versions yet.",
    "columns": {
      "version": "Version",
      "created": "Created",
      "photos": "Photos",
      "cases": "Cases",
      "extends": "Extends",
      "lastPassRate": "Last pass rate",
      "source": "Source",
      "note": "Note"
    },
    "details": {
      "summary": "ⓘ v{version}",
      "goldenSet": "Golden set",
      "goldenSetValue": "v{version}",
      "extendsValue": "v{version} (extends v{extends})",
      "created": "Created",
      "source": "Source",
      "cases": "Cases",
      "casesValue": "{cases} cases in {photos} photos",
      "signedOff": "Signed off",
      "signOff": "{by} on {at}",
      "note": "Note",
      "lastPassRate": "Last pass rate",
      "notRecorded": "not recorded",
      "none": "none",
      "noRun": "no run yet"
    },
    "versionLabel": "v{version}",
    "versionHeading": "Golden v{version}",
    "versionLoading": "Loading this version...",
    "versionError": "This golden version could not be loaded.",
    "versionNotFound": "This golden version was not found.",
    "backToVersions": "All versions",
    "photoCap": "{photos} / {max} photos",
    "caseCap": "{cases} / {max} cases",
    "photoMeta": "Camp {clientId}, album {albumId}: {reason}",
    "caseLine": "Person {personId}: {truth}, {kind}, baseline {baselineScore}, latest {score}, {refs} refs",
    "queueCase": "Queue remove case",
    "unqueueCase": "Unqueue case",
    "queuePhoto": "Queue remove photo {photoId} ({cases} cases)",
    "queuePhotoOne": "Queue remove photo {photoId} (1 case)",
    "unqueuePhoto": "Unqueue photo {photoId}",
    "apply": "Apply {count} removals",
    "applyOne": "Apply 1 removal",
    "clear": "Clear",
    "queued": "queued: {items} → {cases} cases, {photos} photos after apply",
    "queuedPhoto": "photo {photoId}",
    "queuedCase": "{photoId} #{personId}",
    "confirmTitle": "Apply the queued removals?",
    "confirmApply": "Write one new version without {count} queued removals? {gone} cases go; {left} remain.",
    "confirmButton": "Apply",
    "conflict": "Someone else changed the golden set. Reload and try again.",
    "editError": "The golden set could not be changed.",
    "openCase": "Review"
  },
  "photo": {
    "missing": "No photo",
    "enlarged": "Enlarged photo",
    "showBoxes": "Show boxes",
    "hideBoxes": "Hide boxes",
    "close": "Close"
  },
  "inspector": {
    "heading": "Inspect this run",
    "help": "Pick a photo, then click a face to see its matches below.",
    "compareWith": "Compare with",
    "compareNone": "(none)",
    "compareOption": "{startedAt} (v{goldenVersion})",
    "compareLoading": "Loading run {runId}...",
    "compareError": "Run {runId} could not be loaded.",
    "noCompare": "Pick a run to compare with.",
    "noFaceRecorded": "no face recorded",
    "noFacesOnPhoto": "The run recorded no face on this photo.",
    "legend": [
      "Green: the camper would be tagged (score at or over the camp's cut-off: 75, or 70 for camps 187 and 754).",
      "Amber: a near miss, scored 50 or more but under the cut-off. Not tagged.",
      "Red: a flip. The tag changed since the compared run.",
      "Scan: the Rekognition call. SearchUsersByImage checks a face in a newly published photo against every camper. SearchFaces searches one camper across photos already posted; it is the retroactive scan.",
      "References: the frozen photos the camper was enrolled with, the same every run.",
      "Verdict: only a flip asks for one, on its card above. Accept means the engine's new answer is right; wrong means it is not. It is the same answer as accept or wrong in the golden review."
    ],
    "noFaces": "This run has no recorded faces, or media does not serve them yet.",
    "photoItem": "photo {photoId}",
    "photoCounts": "{accepted} accepted, {recorded} recorded",
    "crossCamp": ", cross-camp",
    "thisRun": "run {runId}",
    "runBefore": "compared with {runId}",
    "rebaseline": "Re-baseline: the run before scored another golden version, so there is no comparison.",
    "face": "face {n}",
    "columns": {
      "face": "Face",
      "scan": "Scan",
      "camper": "Camper",
      "score": "Score",
      "state": "State",
      "before": "Compared run",
      "change": "Change",
      "references": "References (frozen)",
      "truth": "Truth"
    },
    "retroactive": "retroactive",
    "stateLine": "{state} (cut-off {threshold})",
    "noRefs": "none frozen",
    "candidatesHeading": "Candidates by photo",
    "candidatesNote": "Rekognition records every match at 50 or above. Accepted means it met the camp's cut-off (75, or 70 for 187 and 754).",
    "candidatesHelp": "{accepted} accepted and {near} near-misses over {photos} photos. Weakest accepted first. Click a photo to inspect it.",
    "candidateColumns": {
      "photo": "Photo",
      "accepted": "Accepted",
      "near": "Near-misses",
      "weakest": "Weakest accepted",
      "closest": "Closest near-miss",
      "person": "Person",
      "rank": "Rank",
      "score": "Score",
      "cutoff": "Cut-off"
    },
    "everyCandidate": "Every candidate ({count})",
    "changes": {
      "flip": "flip",
      "shift": "shift",
      "": "same"
    },
    "noTruth": "—"
  },
  "review": {
    "heading": "Review one case at a time",
    "position": "{pos} of {total} · {red} red · {settled} settled",
    "camper": "camper #{personId}",
    "saved": "saved: {verdict}",
    "confidence": "confidence",
    "cutoffLabel": "Confidence cut-off",
    "includeSettled": "include settled",
    "counts": "photos {photos}/{maxPhotos} · cases {cases}/{maxCases}",
    "where": "camp {clientId} · album {albumId} · photo {photoId}",
    "openAlbum": "Open in album",
    "reason": "Why it is in the set: {reason}",
    "noReason": "(no reason recorded)",
    "kind": " · kind {kind}",
    "baseline": "baseline",
    "nonMatch": "non-match",
    "latest": "latest run",
    "notScored": "not scored",
    "noRun": "no run yet",
    "run": "run {runId} · {startedAt}",
    "cutoff": "cut-off",
    "photoCaption": "photo {photoId}",
    "noBox": " · no face box",
    "trainingCaption": "training {n} of {total}",
    "noTraining": "No training photo",
    "keys": [
      ["A", "accept"],
      ["W", "wrong"],
      ["U", "unsure"],
      ["← / →", "or"],
      ["Shift+Tab / Tab", "move"],
      ["Esc", "all cases"]
    ],
    "notePlaceholder": "note (saved with the verdict)",
    "prev": "Previous",
    "next": "Next",
    "allCases": "All cases",
    "noBoxVerdict": "No matched face on this case, so no verdict can be stored.",
    "noRunVerdict": "No run on this golden version yet, so no verdict can be stored.",
    "saving": "saving...",
    "notSaved": "not saved",
    "end": "End of the list.",
    "empty": "This version has no cases.",
    "verdicts": {
      "accept": "accept",
      "reject": "wrong",
      "unsure": "unsure"
    },
    "status": {
      "pass": "pass",
      "regressed": "regressed",
      "unscored": "unscored"
    },
    "enlargeHint": "click the photo to enlarge it (B toggles boxes)",
    "open": "Review one case at a time (Enter)"
  },
  "theme": {
    "dark": "Dark mode",
    "light": "Light mode"
  }
}
